export default __webpack_public_path__ + "static/wsl-meshery-login-success-69ba1b78ae21f659862cd7b906de26a8.webp";